export const HotTYPE = ['Slots', 'LiveCasino', 'Casino'];
export const NotShowAll = ['CrashGame', 'Evolution', 'QuickGame'];
export const NotLive = ['HotMatches'];
